export default __webpack_public_path__ + "static/media/newhirechecklist.df78d53e.png";